import { sizing, type SizingProps } from '@material-ui/system'
import styled from 'styled-components'

interface ICreditCardIconStyledProps extends SizingProps {}

export const CreditCardIconStyled = styled.div<ICreditCardIconStyledProps>`
  img {
    display: block;
    ${sizing};
  }
`
